var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7654 1.33565C13.1062 1.74843 13.0716 2.3805 12.6883 2.74742L4.3312 10.7474C3.97938 11.0842 3.4492 11.0842 3.09738 10.7474L0.311672 8.08075C-0.0716261 7.71383 -0.106151 7.08176 0.234558 6.66897C0.575267 6.25619 1.16219 6.21901 1.54549 6.58593L3.71429 8.66205L11.4545 1.2526C11.8378 0.885684 12.4247 0.922864 12.7654 1.33565Z",
    fill: "#009FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8304 2.93427C19.3464 2.47562 19.3929 1.68553 18.9343 1.16956C18.4756 0.653578 17.6855 0.607102 17.1695 1.06575L9 8.32756L6.83046 6.39908C6.31449 5.94043 5.5244 5.9869 5.06575 6.50288C4.6071 7.01886 4.65358 7.80895 5.16956 8.2676L8.16955 10.9343C8.64316 11.3552 9.35685 11.3552 9.83046 10.9343L18.8304 2.93427Z",
    fill: "#009FFF",
    stroke: "#302C55",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTick);
export default __webpack_public_path__ + "static/media/BlueTick.5eb98bc54d224c0927e4b12f14c06ba2.svg";
export { ForwardRef as ReactComponent };